import axiosInstance from '@/utils/api.js'

var state = {
}

var getters = {
}

var mutations = {
}

var actions = {
  GET_REPORT_PAYMENTS: (context, payload) => {
    return axiosInstance.get('/settings/tel_suppliers/report_of_payments?supplier_id=' + payload.supplier_id +
    '&start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd)
  },
  GET_REPORT_CHARGES: (context, payload) => {
    return axiosInstance.get('/settings/tel_suppliers/report_of_charges?supplier_id=' + payload.supplier_id +
    '&start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd)
  },
  GET_REPORT_USERS: (context, payload) => {
    return axiosInstance.get('/settings/tel_suppliers/report_of_users?supplier_id=' + payload.supplier_id +
    '&start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd)
  },
  GET_REPORT_INVOICES: (context, payload) => {
    return axiosInstance.get('/settings/tel_suppliers/report_of_invoices?supplier_id=' + payload.supplier_id +
    '&start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/telSupplierServiceReports.js